var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('wrapper',{staticClass:"wrapper",attrs:{"backgroundImage":_vm.configuratorData.CityMap ? _vm.configuratorData.CityMap.url : ''}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }